export default "__VITE_ASSET__B7zSRP48__"